import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import Input from "../../../components/common/inputs/Input";
import Select from "../../../components/common/inputs/Select";
import Button from "../../../components/common/button/Button";
import { postApi } from "../../../services/api/globalApi";
import {
  successMessage,
  warningMessage,
} from "../../../utils/toastify-message/ToastifyMessage";
import { affiliateLevelDiscountValidation } from "../../../utils/validation/discount/affiliateLevelDiscountValidation";
import CurrencyInput from "../../../components/common/inputs/CurrencyInput";

function AffiliateLevelDiscount({ data }) {
  const [level, setLevel] = useState([]);
  const formHandler = (values, { resetForm }) => {
    values["isActive"] = values.isActive == "true" ? true : false;
    const isExist = level.filter((item) => {
      return item.name == values.name;
    });
    if (isExist.length) {
      warningMessage("این تخفیف از قبل وجود دارد.");
    } else {
      setLevel((prev) => [...prev, values]);
      resetForm();
      reset();
    }
  };

  useEffect(() => {
    setLevel(data || []);
  }, [data]);

  const handle = async () => {
    const path = "admin/discounts";
    const body = {
      affiliateLevelDiscount: level,
    };
    try {
      const data = await postApi({ path, body });
      console.log(data);
      successMessage("تخفیف با موفقیت بروزرسانی شد.");
    } catch (error) {
      console.log(error);
    }
  };

  const percentRef = useRef();
  const minPriceRef = useRef();
  const maxPriceRef = useRef();

  const reset = () => {
    percentRef.current.afterSubmit();
    minPriceRef.current.afterSubmit();
    maxPriceRef.current.afterSubmit();
  };

  const deleteDiscount = (data) => {
    const newLevel = level.filter((item) => {
      return item.name !== data?.name;
    });
    setLevel(newLevel);
  };

  console.log(level);

  return (
    <div className="w-full py-4 px-4 border-r border-l">
      <Formik
        enableReinitialize
        initialValues={{
          name: "",
          percent: "",
          minPrice: "",
          maxPrice: "",
          isActive: "true",
        }}
        validationSchema={affiliateLevelDiscountValidation}
        onSubmit={formHandler}
      >
        {(formik) => (
          <Form>
            <div className="grid gap-6 mb-4 md:grid-cols-2">
              <Input name="name" placeholder="نام" label="نام" type="text" />
              <div>
                <label
                  for="large-input"
                  className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  درصد
                </label>
                <CurrencyInput
                  placeholder="درصد"
                  ref={percentRef}
                  name="percent"
                  inputValue={formik.values["percent"]}
                  onChange={(e) => formik.setFieldValue("percent", e)}
                />
                {formik.errors.percent && formik.touched.percent ? (
                  <p className="text-sm my-4 text-red-500">
                    {formik.errors.percent}
                  </p>
                ) : null}
              </div>
              <div>
                <label
                  for="large-input"
                  className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  کف قیمت
                </label>
                <CurrencyInput
                  placeholder="کف قیمت"
                  ref={minPriceRef}
                  name="minPrice"
                  inputValue={formik.values["minPrice"]}
                  onChange={(e) => formik.setFieldValue("minPrice", e)}
                />
                {formik.errors.minPrice && formik.touched.minPrice ? (
                  <p className="text-sm my-4 text-red-500">
                    {formik.errors.minPrice}
                  </p>
                ) : null}
              </div>

              <div>
                <label
                  for="large-input"
                  className="backdrop-blur block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  سقف قیمت
                </label>
                <CurrencyInput
                  placeholder="سقف قیمت"
                  ref={maxPriceRef}
                  name="maxPrice"
                  inputValue={formik.values["maxPrice"]}
                  onChange={(e) => formik.setFieldValue("maxPrice", e)}
                />
                {formik.errors.maxPrice && formik.touched.maxPrice ? (
                  <p className="text-sm my-4 text-red-500">
                    {formik.errors.maxPrice}
                  </p>
                ) : null}
              </div>
              <Select
                name="isActive"
                placeholder="فعال باشه؟"
                label="فعال باشه؟"
              >
                <option value={"true"}>بله</option>
                <option value={"false"}>خیر</option>
              </Select>
              <div className="flex flex-col gap-y-2">
                <div className="mt-6">
                  <Button text={"افزودن درجه"} color={"success"} />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>

      <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
        {level.length ? (
          <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" class="px-6 py-3">
                  نام
                </th>
                <th scope="col" class="px-6 py-3">
                  درصد تخفیف
                </th>
                <th scope="col" class="px-6 py-3">
                  کفش
                </th>
                <th scope="col" class="px-6 py-3">
                  سقفش
                </th>
                <th scope="col" class="px-6 py-3">
                  وضعیت
                </th>
                <th scope="col" class="px-6 py-3">
                  عملیات
                </th>
              </tr>
            </thead>
            <tbody>
              {level.map((item) => {
                return (
                  <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                    <th
                      scope="row"
                      class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                    >
                      {item.name}
                    </th>
                    <td class="px-6 py-4">{item.percent}</td>
                    <td class="px-6 py-4">{item.minPrice}</td>
                    <td class="px-6 py-4">{item.maxPrice}</td>
                    <td class="px-6 py-4">
                      {item.isActive ? "فعال" : "غیر فعال"}
                    </td>
                    <td class="px-6 py-4 text-right">
                      <button
                        onClick={() => deleteDiscount(item)}
                        class="font-medium text-red-600 dark:text-red-500 hover:underline"
                      >
                        حذف
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div className="w-full flex items-center justify-center my-3 py-2">
            <p>هیچ تخفیفی هنوز ساخته نشده است.</p>
          </div>
        )}
      </div>
      <div className="flex flex-col gap-y-2">
        <div className="mt-6">
          <Button
            onClick={handle}
            type="button"
            text={"بروزرسانی تخفیف"}
            color={"success"}
          />
        </div>
      </div>
    </div>
  );
}

export default AffiliateLevelDiscount;
